import { ReactNode } from "react";
import { StyleProp, StyleSheet, View, ViewStyle } from "react-native";

import { Text, Token, Tooltip } from "@ctv/shared-core/src";

import StatusInfo from "@traveloka/icon-kit-web/react/IcSystemStatusInfoFill12";

import RequiredLabel from "./RequiredLabel";

type FieldRowProps = {
  children: ReactNode;
  label?: string;
  subLabel?: string | null;
  tooltip?: string | null;
  tooltipPosition?: "top" | "bottom";
  required?: boolean;
  style?: StyleProp<ViewStyle>;
  labelStyle?: StyleProp<ViewStyle>;
};

export function FieldRow(props: FieldRowProps) {
  const {
    children,
    label,
    required,
    subLabel,
    tooltip,
    tooltipPosition,
    style,
    labelStyle,
  } = props;

  return (
    <View style={[styles.row, style]}>
      <View style={[styles.labelContainer, labelStyle]}>
        {Boolean(label) && (
          <>
            <Text variant="ui-small-bold" style={styles.label}>
              {label}
              {required && <RequiredLabel />}
              {tooltip && (
                <Tooltip
                  position={tooltipPosition || "top"}
                  variant="info"
                  width={404}
                  content={
                    <Text variant="ui-small" ink="white-primary">
                      {tooltip}
                    </Text>
                  }
                  offset={{ x: Token.spacing.xxs }}
                >
                  <View style={styles.marginLeftXS}>
                    <StatusInfo
                      accentColor={Token.color.blueDark}
                      color={Token.color.blueDark}
                      width={12}
                      height={12}
                    />
                  </View>
                </Tooltip>
              )}
            </Text>
            {subLabel && (
              <Text
                style={styles.subLabel}
                variant="ui-tiny"
                ink="black-secondary"
              >
                {subLabel}
              </Text>
            )}
          </>
        )}
      </View>
      <View style={styles.contentContainer}>{children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "flex-start",
  },
  labelContainer: {
    width: 207,
    zIndex: 1,
    paddingTop: Token.spacing.xxs,
  },
  label: {
    marginEnd: Token.spacing.m,
  },
  subLabel: {
    marginTop: Token.spacing.xxs,
  },
  contentContainer: {
    flex: 1,
  },

  // General Styles
  marginLeftXS: {
    marginLeft: Token.spacing.xs,
  },
});
